var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "logo-container",
      class:
        ((_obj = {}),
        (_obj["logo-container-" + _vm.theme.layout] = true),
        _obj),
    },
    [
      _vm.collapse
        ? _c("img", {
            staticClass: "menu_logo",
            attrs: { src: require("@/assets/images/menu_logo_x.png") },
            on: { click: _vm.toggleCollapse },
          })
        : _c("img", {
            staticClass: "menu_close",
            attrs: { src: require("@/assets/images/menu_close_x.png") },
            on: { click: _vm.toggleCollapse },
          }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }